import { OBSTACLE_TYPE, CHARACTER_TYPES } from './../../../f.assets/Characters/scripts/constants'
import { COMMANDERS } from './../../../c.managers/LevelManager/store.d'
import { Vector2 } from 'three'
import { default as SPELLS } from '../../GameElements/classes/Spells'

export const level1Config = {
  id: 'level1',
  name: 'Père-Lachaise',
  newSpell: SPELLS.SPARK,
  players: [
    {
      id: COMMANDERS.PLAYER,
      // team: CHARACTER_TYPES.JACK,
      level: 1,
      manaLevel: 0,
      maxManaLevel: 50,
      spells: [
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
      ],
      activeSpells: [],
    },
    {
      id: COMMANDERS.COM,
      // team: CHARACTER_TYPES.WITCH,
      level: 1,
      manaLevel: 0,
      maxManaLevel: 50,
      spells: [
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
      ],
      activeSpells: [],
    },
  ],
  characters: [
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(0, 10),
      owner: COMMANDERS.PLAYER,
      tickDivisions: [Math.floor(Math.random() * 4)],
      // tickDivisions: [0, 2], // twice the speed
      // variant: CHARACTER_VARIANTS.DIABLO
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(0, 9),
      owner: COMMANDERS.PLAYER,
      tickDivisions: [Math.floor(Math.random() * 4)],
      // tickDivisions: [0, 2], // twice the speed
      // variant: CHARACTER_VARIANTS.DIABLO
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(15, 0),
      owner: COMMANDERS.COM,
      tickDivisions: [Math.floor(Math.random() * 4)],
      // tickDivisions: [0, 2], // twice the speed
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(15, 1),
      owner: COMMANDERS.COM,
      tickDivisions: [Math.floor(Math.random() * 4)],
      // tickDivisions: [0, 2], // twice the speed
    },
  ],
  obstacles: [
    // upper left
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(11, 1),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(11, 2),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(11, 3),
    },
    // upper right
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(11, 7),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(11, 8),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(11, 9),
    },
    // center left
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(8, 0),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(8, 1),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(8, 2),
    },
    // center right
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(7, 8),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(7, 9),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(7, 10),
    },
    // bottom left
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(4, 1),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(4, 2),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(4, 3),
    },
    // bottom right
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(4, 7),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(4, 8),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(4, 9),
    },
  ],
  treasures: [
    {
      coords: new Vector2(1, 1),
      owner: COMMANDERS.PLAYER,
      amount: 500,
    },
    {
      coords: new Vector2(14, 9),
      owner: COMMANDERS.COM,
      amount: 500,
    },
  ],
}

export const level2Config = {
  id: 'level2',
  name: 'La Recoleta',
  newSpell: SPELLS.CANDY_SWORD,
  players: [
    {
      id: COMMANDERS.PLAYER,
      team: CHARACTER_TYPES.JACK,
      level: 1,
      manaLevel: 0,
      maxManaLevel: 60,
      spells: [
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
      ],
      activeSpells: [],
    },
    {
      id: COMMANDERS.COM,
      team: CHARACTER_TYPES.WITCH,
      level: 1,
      manaLevel: 0,
      maxManaLevel: 60,
      spells: [
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.PETRIFY_MINION, id: Math.random() },
        { ...SPELLS.PETRIFY_MINION, id: Math.random() },
      ],
      activeSpells: [],
    },
  ],
  characters: [
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(0, 10),
      owner: COMMANDERS.PLAYER,
      tickDivisions: [Math.floor(Math.random() * 4)],
      // tickDivisions: [0, 2], // twice the speed
      // variant: CHARACTER_VARIANTS.DIABLO
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(0, 9),
      owner: COMMANDERS.PLAYER,
      tickDivisions: [Math.floor(Math.random() * 4)],
      // tickDivisions: [0, 2], // twice the speed
      // variant: CHARACTER_VARIANTS.DIABLO
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(0, 8),
      owner: COMMANDERS.PLAYER,
      tickDivisions: [Math.floor(Math.random() * 4)],
      // tickDivisions: [0, 2], // twice the speed
      // variant: CHARACTER_VARIANTS.DIABLO
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(15, 0),
      owner: COMMANDERS.COM,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(15, 1),
      owner: COMMANDERS.COM,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(15, 2),
      owner: COMMANDERS.COM,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
  ],
  obstacles: [
    // upper left
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(9, 1),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(9, 2),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(9, 3),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(9, 4),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(9, 5),
    },
    // upper T
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(14, 5),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(13, 5),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 2),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 3),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 4),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 5),
    },

    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 8),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 9),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 10),
    },

    // bottom right
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(6, 5),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(6, 6),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(6, 7),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(6, 8),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(6, 9),
    },
    // bottom T
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(1, 5),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(2, 5),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 5),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 1),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 2),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 0),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 6),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 7),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 8),
    },
  ],
  treasures: [
    {
      coords: new Vector2(1, 1),
      owner: COMMANDERS.PLAYER,
      amount: 500,
    },
    {
      coords: new Vector2(14, 9),
      owner: COMMANDERS.COM,
      amount: 500,
    },
  ],
}

export const level3Config = {
  id: 'level3',
  name: 'Arlington National',
  newSpell: SPELLS.PETRIFY_MINION,
  players: [
    {
      id: COMMANDERS.PLAYER,
      team: CHARACTER_TYPES.JACK,
      level: 1,
      manaLevel: 0,
      maxManaLevel: 70,
      spells: [
        { ...SPELLS.PETRIFY_MINION, id: Math.random() },
        { ...SPELLS.PETRIFY_MINION, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
      ],
      activeSpells: [],
    },
    {
      id: COMMANDERS.COM,
      team: CHARACTER_TYPES.WITCH,
      level: 1,
      manaLevel: 0,
      maxManaLevel: 70,
      spells: [
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.PETRIFY_MINION, id: Math.random() },
        { ...SPELLS.PETRIFY_MINION, id: Math.random() },
        { ...SPELLS.FIREBALL, id: Math.random() },
        { ...SPELLS.FIREBALL, id: Math.random() },
      ],
      activeSpells: [],
    },
  ],
  characters: [
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(0, 10),
      owner: COMMANDERS.PLAYER,
      tickDivisions: [Math.floor(Math.random() * 4)],
      // tickDivisions: [0, 2], // twice the speed
      // variant: CHARACTER_VARIANTS.DIABLO
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(0, 9),
      owner: COMMANDERS.PLAYER,
      tickDivisions: [Math.floor(Math.random() * 4)],
      // tickDivisions: [0, 2], // twice the speed
      // variant: CHARACTER_VARIANTS.DIABLO
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(0, 8),
      owner: COMMANDERS.PLAYER,
      tickDivisions: [Math.floor(Math.random() * 4)],
      // tickDivisions: [0, 2], // twice the speed
      // variant: CHARACTER_VARIANTS.DIABLO
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(15, 0),
      owner: COMMANDERS.COM,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(15, 1),
      owner: COMMANDERS.COM,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(15, 2),
      owner: COMMANDERS.COM,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
  ],
  obstacles: [
    // LEFT
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(7, 0),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(8, 0),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(7, 1),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(8, 1),
    },
    // LEFT L
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(5, 1),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(4, 1),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 1),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 2),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 3),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 4),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 5),
    },
    // MIDDLE
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(7, 4),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(8, 4),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(7, 5),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(8, 5),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(7, 6),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(8, 6),
    },
    // RIGHT
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(7, 9),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(8, 9),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(7, 10),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(8, 10),
    },
    // // RIGHT L
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(10, 9),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(11, 9),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 9),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 8),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 7),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 6),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 5),
    },
  ],
  treasures: [
    {
      coords: new Vector2(1, 1),
      owner: COMMANDERS.PLAYER,
      amount: 500,
    },
    {
      coords: new Vector2(14, 9),
      owner: COMMANDERS.COM,
      amount: 500,
    },
  ],
}

export const level4Config = {
  id: 'level4',
  name: 'Zentralfriedhof',
  newSpell: SPELLS.FIREBALL,
  players: [
    {
      id: COMMANDERS.PLAYER,
      team: CHARACTER_TYPES.JACK,
      level: 1,
      manaLevel: 0,
      maxManaLevel: 80,
      spells: [
        { ...SPELLS.FIREBALL, id: Math.random() },
        { ...SPELLS.FIREBALL, id: Math.random() },
        { ...SPELLS.PETRIFY_MINION, id: Math.random() },
        { ...SPELLS.PETRIFY_MINION, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
      ],
      activeSpells: [],
    },
    {
      id: COMMANDERS.COM,
      team: CHARACTER_TYPES.WITCH,
      level: 1,
      manaLevel: 0,
      maxManaLevel: 80,
      spells: [
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.PETRIFY_MINION, id: Math.random() },
        { ...SPELLS.PETRIFY_MINION, id: Math.random() },
        { ...SPELLS.FIREBALL, id: Math.random() },
        { ...SPELLS.FIREBALL, id: Math.random() },
        { ...SPELLS.DEVIL_MINION, id: Math.random() },
      ],
      activeSpells: [],
    },
  ],
  characters: [
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(0, 10),
      owner: COMMANDERS.PLAYER,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(0, 9),
      owner: COMMANDERS.PLAYER,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(0, 8),
      owner: COMMANDERS.PLAYER,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(0, 7),
      owner: COMMANDERS.PLAYER,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(15, 0),
      owner: COMMANDERS.COM,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(15, 1),
      owner: COMMANDERS.COM,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(15, 2),
      owner: COMMANDERS.COM,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(15, 3),
      owner: COMMANDERS.COM,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
  ],
  obstacles: [
    // upper left
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 10),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 9),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 8),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 7),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 6),
    },

    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(11, 2),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(11, 3),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(11, 4),
    },

    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(9, 2),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(8, 2),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(7, 2),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(6, 2),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(5, 2),
    },

    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(10, 8),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(9, 8),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(8, 8),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(7, 8),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(6, 8),
    },

    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 0),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 1),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 2),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 3),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 4),
    },

    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(4, 6),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(4, 7),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(4, 8),
    },
  ],
  treasures: [
    {
      coords: new Vector2(1, 1),
      owner: COMMANDERS.PLAYER,
      amount: 500,
    },
    {
      coords: new Vector2(14, 9),
      owner: COMMANDERS.COM,
      amount: 500,
    },
  ],
}

export const level5Config = {
  id: 'level5',
  name: 'Greyfriars Kirkyard',
  newSpell: SPELLS.DEVIL_MINION,
  players: [
    {
      id: COMMANDERS.PLAYER,
      team: CHARACTER_TYPES.JACK,
      level: 1,
      manaLevel: 0,
      maxManaLevel: 90,
      spells: [
        { ...SPELLS.DEVIL_MINION, id: Math.random() },
        { ...SPELLS.FIREBALL, id: Math.random() },
        { ...SPELLS.FIREBALL, id: Math.random() },
        { ...SPELLS.PETRIFY_MINION, id: Math.random() },
        { ...SPELLS.PETRIFY_MINION, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
      ],
      activeSpells: [],
    },
    {
      id: COMMANDERS.COM,
      team: CHARACTER_TYPES.WITCH,
      level: 1,
      manaLevel: 0,
      maxManaLevel: 90,
      spells: [
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.GRAVE, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.SPARK, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.CANDY_SWORD, id: Math.random() },
        { ...SPELLS.PETRIFY_MINION, id: Math.random() },
        { ...SPELLS.PETRIFY_MINION, id: Math.random() },
        { ...SPELLS.FIREBALL, id: Math.random() },
        { ...SPELLS.FIREBALL, id: Math.random() },
        { ...SPELLS.DEVIL_MINION, id: Math.random() },
        { ...SPELLS.MASTER, id: Math.random() },
      ],
      activeSpells: [],
    },
  ],
  characters: [
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(0, 10),
      owner: COMMANDERS.PLAYER,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(0, 9),
      owner: COMMANDERS.PLAYER,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(0, 8),
      owner: COMMANDERS.PLAYER,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(0, 7),
      owner: COMMANDERS.PLAYER,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(15, 0),
      owner: COMMANDERS.COM,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(15, 1),
      owner: COMMANDERS.COM,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(15, 2),
      owner: COMMANDERS.COM,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
    {
      type: CHARACTER_TYPES.BASIC_MINION,
      coords: new Vector2(15, 3),
      owner: COMMANDERS.COM,
      tickDivisions: [Math.floor(Math.random() * 4)],
    },
  ],
  obstacles: [
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 8),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(11, 8),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(10, 8),
    },
    // upper center
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 7),
    },

    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 4),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 3),
    },

    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(12, 2),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(11, 2),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(10, 2),
    },

    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(8, 0),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(8, 1),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(8, 2),
    },

    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(7, 10),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(7, 9),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(7, 8),
    },

    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(5, 8),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(4, 8),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 8),
    },

    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 8),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 7),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 6),
    },

    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 3),
    },

    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(5, 2),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(4, 2),
    },
    {
      type: OBSTACLE_TYPE.BASIC,
      coords: new Vector2(3, 2),
    },
  ],
  treasures: [
    {
      coords: new Vector2(1, 1),
      owner: COMMANDERS.PLAYER,
      amount: 500,
    },
    {
      coords: new Vector2(14, 9),
      owner: COMMANDERS.COM,
      amount: 500,
    },
  ],
}

export const getFlawlessScore = () => {
  const maxScore = [level1Config, level2Config, level3Config, level4Config, level5Config].reduce(
    (total: number, c: typeof level1Config) => {
      total += c.treasures[0].amount
      return total
    },
    0,
  )
  return maxScore
}

export const terrainPlotsCoords = [
  new Vector2(0, 10),
  new Vector2(0, 9),
  new Vector2(0, 8),
  new Vector2(0, 7),
  new Vector2(15, 0),
  new Vector2(15, 1),
  new Vector2(15, 2),
  new Vector2(15, 3),
]
